import React from "react";
import { Container } from "react-bootstrap";
import "../Scan/Scan.css";
import { Link } from "react-router-dom";

const Scan = ({ bgimg, scantitle, scanbtn }) => {
  return (
    <>
      <div className="scan-section" id="star-for-free">
        <Container>
          <div className="scan-content" style={bgimg}>
            <div className="section-title">
              <h2>{scantitle}</h2>
            </div>
            <div className="scan-btn">
              <Link to="/" className="btn btn-white-blue">{scanbtn}</Link>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Scan;
